import { SelectionModel } from "@angular/cdk/collections";
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { JudgeInfo } from "../../application/application.service";

@Component({
    selector: 'dialog-judgeselect-component',
    styleUrls: ['judgeselect.dialogcomponent.scss'],
    templateUrl: 'judgeselect.dialogcomponent.html',
})

export class JudgeSelectDialogComponent implements OnInit, AfterViewInit {
    displayedColumns: string[] = ['Select', 'SortableName', 'NomineeTypeName', 'JudgingPhase', 'DistrictNumber'];
    dataSource: MatTableDataSource<JudgeInfo>;
    selection = new SelectionModel<JudgeInfo>(false, []);
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    loading: boolean = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<JudgeSelectDialogComponent>
    ) { }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
    }

    ngOnInit() {
        let judges: JudgeInfo[] = this.data;
        this.dataSource = new MatTableDataSource(judges);
        this.loading = false;
    }

    OKHandler() {
        this.dialogRef.close(this.selection.selected[0]);
    }

    CancelHandler() {
        this.dialogRef.close(null);
    }

}